<template>
    <div class="contact contact-telegram" :class="`contact-telegram-${style_class}`">
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" stroke-width=".3" :stroke="`${stroke_color}`" class="svg-fill" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.753 0.589355C15.5575 0.350342 15.2648 0.21875 14.9286 0.21875C14.7459 0.21875 14.5523 0.257202 14.3533 0.333252L0.809595 5.5033C0.0908454 5.77759 -0.00595633 6.18921 0.000269252 6.41016C0.00649483 6.6311 0.12649 7.03662 0.859644 7.2699C0.864039 7.27124 0.868433 7.27258 0.872828 7.2738L3.68215 8.07776L5.20144 12.4222C5.40859 13.0145 5.87356 13.3824 6.41506 13.3824C6.75649 13.3824 7.09231 13.2394 7.38626 12.9689L9.12393 11.3689L11.6443 13.3983C11.6446 13.3986 11.6449 13.3987 11.6452 13.3989L11.6691 13.4182C11.6713 13.4199 11.6736 13.4218 11.6758 13.4235C11.956 13.6407 12.2617 13.7555 12.5604 13.7556H12.5606C13.1442 13.7556 13.6089 13.3236 13.7443 12.6552L15.9634 1.69763C16.0525 1.25781 15.9778 0.864258 15.753 0.589355ZM4.62197 7.92505L10.042 5.15613L6.66714 8.74219C6.61184 8.8009 6.57266 8.8728 6.55337 8.95105L5.90261 11.587L4.62197 7.92505ZM6.75112 12.2792C6.72866 12.2998 6.70608 12.3182 6.6835 12.3352L7.28726 9.88989L8.38552 10.7743L6.75112 12.2792ZM15.0446 1.51147L12.8255 12.4691C12.8041 12.574 12.7359 12.818 12.5604 12.818C12.4738 12.818 12.3649 12.7708 12.2534 12.6849L9.39749 10.3854C9.39712 10.385 9.39663 10.3846 9.39614 10.3844L7.6968 9.01599L12.5773 3.83008C12.7335 3.66406 12.7477 3.40979 12.6109 3.22742C12.4739 3.04504 12.2257 2.98767 12.0227 3.09143L3.99563 7.19226L1.1481 6.37756L14.6876 1.20911C14.802 1.16541 14.8819 1.15625 14.9286 1.15625C14.9573 1.15625 15.0083 1.15967 15.0272 1.18298C15.0521 1.21338 15.0839 1.31702 15.0446 1.51147Z" fill="#41B4E6"/>
        </svg>
        <span>Пишите нам в Телегамм</span>
    </div>
</template>

<script>
    export default {
        name: "TelegramButton",
        props: {
            style_class: {
                type: String,
                default: ''
            }
        },
        computed: {
            stroke_color() {
                return this.style_class === 'white' ? '#878EA0' : '#41B4E6'
            }
        }
    };
</script>

<style scoped lang="scss">
    .contact {
        span {
         cursor: pointer;
        }
    }

</style>
